/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_mobile_analytics_app_id": "f731b7feb8c34defa11e5d1be7107215",
    "aws_mobile_analytics_app_region": "ap-northeast-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "f731b7feb8c34defa11e5d1be7107215",
            "region": "ap-northeast-1"
        }
    },
    "aws_cloud_logic_custom": [
        {
            "name": "citizen",
            "endpoint": "https://66hcjuaeg5.execute-api.ap-northeast-1.amazonaws.com/snjk",
            "region": "ap-northeast-1"
        },
        {
            "name": "public",
            "endpoint": "https://8u839ea50d.execute-api.ap-northeast-1.amazonaws.com/snjk",
            "region": "ap-northeast-1"
        }
    ],
    "aws_cognito_identity_pool_id": "ap-northeast-1:201941cc-423b-4c35-8a30-f4023189306b",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_DgQqT7gGr",
    "aws_user_pools_web_client_id": "7ne41mstg0a0liib4h4cpa0rqr",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": "6",
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
